import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { elementTraversal } from "../../actionHelpers/elementTraversal";
import { cloneDeep } from "lodash";
import {
  TWebsiteBuilderElementData,
  TWebsiteBuilderElementSettings,
  TWebsiteBuilderElementType,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";

type TPickElementTypeAndSettings<T> = T extends {
  type: TWebsiteBuilderElementType;
  settings: TWebsiteBuilderElementSettings;
}
  ? Pick<T, "type" | "settings">
  : never;

export type TUpdatedElementSettings = TPickElementTypeAndSettings<TWebsiteBuilderElementData>;

export interface IUpdateElementSettingsActionPayload {
  id: string;
  prevElementSettings: TUpdatedElementSettings;
  nextElementSettings: TUpdatedElementSettings;
}

export interface IUpdateElementSettingsAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS;
  payload: IUpdateElementSettingsActionPayload;
}

export function getUpdateElementSettingsInverseAction(
  action: IUpdateElementSettingsAction,
): IUpdateElementSettingsAction {
  const { id, nextElementSettings, prevElementSettings } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevElementSettings: cloneDeep(nextElementSettings),
      nextElementSettings: cloneDeep(prevElementSettings),
    },
  };
}

export function applyUpdateElementSettingsChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateElementSettingsAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextElementSettings } = action.payload;

  return elementTraversal(header, root, footer, id, cloneDeep(nextElementSettings));
}
